import React, { useState, useEffect } from "react";
import TitlePage from "../../../Shared/TitlePage";
import { makeStyles } from "@material-ui/core/styles";
import { getAuth, sendEmailVerification, updatePassword, onAuthStateChanged } from "firebase/auth";
import { dataService } from '../../../../Services/data/data.service';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { IconButton, TextField, Checkbox, Tooltip, InputAdornment, Box } from '@mui/material';
import { Lock, Eye, EyeOff, Save, CircleCheck } from 'lucide-react';


toast.configure();

function UserSettingsPage(props) {
    const classes = useStyles();
    const [verified, setVerified] = useState(false);
    const [changePassword, setChangePassword] = useState(false);
    const [lastName, setLastName] = useState(props.Login.lastName);
    const [firstName, setFirstName] = useState(props.Login.userName);
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = () => setShowPassword(!showPassword);

    useEffect(() => {
        const auth = getAuth();
        onAuthStateChanged(auth, (user) => {
            if (user) {
                // User is signed in, see docs for a list of available properties
                // https://firebase.google.com/docs/reference/js/firebase.User
                // ...
                setVerified(user.emailVerified);
            } else {
                // User is signed out
                // ...
            }
        });
    }, []);


    const handleCheckBox = (e) => {
        setChangePassword(!changePassword);
    }
    const handleVerificationMail = () => {
        const tempAuth = getAuth();

        sendEmailVerification(tempAuth.currentUser)
            .then(() => {
                // Email verification sent!
                // ...
            });
    }
    const handleSaveChanges = () => {
        const auth = getAuth();

        const user = auth.currentUser;
        if (changePassword === true) {
            if (password && password.length > 6) {
                updatePassword(user, password).then(() => {
                    console.log("success")
                    // Update successful.
                }).catch((error) => {
                    // An error ocurred
                    // ...
                    console.log(error);
                });
            } else {
                toast.error('Your new password should be at least 6 characters long', { position: toast.POSITION.TOP_CENTER, autoClose: 2000 })
            }
        }
        if (firstName !== "" || lastName !== "") {
            dataService.updateUserData(user.email, firstName, lastName).then(response => {
                if (response.success === true) {
                    props.actions.setUserName(firstName);
                    props.actions.setLastName(lastName);
                    toast.success('User updated succefully', { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
                } else {
                    toast.error('Something went wrong.', { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
                }


            })
        }

    }

    const changeLastName = (event) => {
        setLastName(event.target.value);
    }

    const changeFirstName = (event) => {
        setFirstName(event.target.value);
    }

    const handleChangePassword = (event) => {
        setPassword(event.target.value);
    }


    return (
        <React.Fragment>
            <TitlePage Text="User settings" backbutton={true} {...props} />
            <Box sx={{
                maxWidth: '480px', display: 'flex', justifyContent: 'center', flexDirection: 'column', marginRight: "auto",
                marginLeft: "auto", marginTop: "148px", padding: "0px 16px",

            }} >
                <div className={classes.header}>
                    <h1>Your account</h1>
                </div>

                <Box className={classes.container}>
                    {!verified &&
                        <div className={classes.verificationContainer}>
                            <h3 className={classes.verificationContainer__title}>You are not verified</h3>
                            <p className={classes.verification__body}>Click the link in the email to verify your account</p>
                            <button className={classes.primaryButton} onClick={() => handleVerificationMail()} >Resend email</button>
                        </div>
                    }
                    <div className={classes.formContainer}>
                        <div className={classes.row}>
                            <span className={classes.labelText}>Email</span>
                            <div className={classes.emailInputContainer}>
                                <TextField
                                    className={classes.textField}
                                    type={"text"}
                                    variant="outlined"
                                    value={props.Login.email}
                                    disabled={true}
                                    fullWidth={true}
                                >
                                </TextField>
                                {verified &&
                                    <Tooltip placement="top" disableInteractive title=" This emailaddress is verified">
                                        <CircleCheck className={classes.verifiedBadge} style={{ marginLeft: '10px', color: 'green' }}></CircleCheck>
                                    </Tooltip>}
                            </div>

                        </div>
                        <div className={classes.row}>
                            <span className={classes.labelText}>First name</span>
                            <TextField
                                className={classes.textField}
                                type={"text"}
                                variant="outlined"
                                onChange={(event) => changeFirstName(event)}

                                value={firstName}
                                fullWidth={true}

                            >
                            </TextField>
                        </div>
                        <div className={classes.row}>
                            <span className={classes.labelText}>Last name</span>
                            <TextField
                                className={classes.textField}
                                type={"text"}
                                variant="outlined"
                                onChange={(event) => changeLastName(event)}

                                value={lastName}
                                fullWidth={true}
                            >
                            </TextField>
                        </div>
                        <div className={classes.row}>
                            <span className={classes.labelText}>Change password <Checkbox style={{ color: '#C3996B' }} onChange={(e) => handleCheckBox(e)}></Checkbox></span>

                            <TextField
                                className={changePassword === false ? classes.disabledTextField : classes.textField}
                                type={showPassword ? "text" : "password"}
                                variant="outlined"
                                value={password}
                                onChange={(event) => handleChangePassword(event)}

                                fullWidth={true}
                                disabled={changePassword === false}
                                InputProps={{
                                    startAdornment:
                                        <InputAdornment position="start">
                                            <Lock style={{ marginRight: '10px' }}></Lock>
                                        </InputAdornment>,
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                            >
                                                {showPassword ? <EyeOff /> : <Eye />}
                                            </IconButton>
                                        </InputAdornment>)
                                }}
                            >
                            </TextField>
                        </div>
                        {/* <button size='large' className={classes.logInButton} variant="contained" onClick={() => handleSaveChanges()}>Save changes</button> */}
                        <div className={classes.buttonContainer}>
                            <button className={classes.primaryIconButton} onClick={() => handleSaveChanges()}>
                                <Save className={classes.iconButton__icon} absoluteStrokeWidth />
                                Save
                            </button>
                        </div>
                    </div>

                </Box>
            </Box>
        </React.Fragment >
    )
}


export default UserSettingsPage;

const useStyles = makeStyles({
    container: {
        boxSizing: "border-box",

        background: "#FFFFFF",
        borderRadius: "8px",
        padding: "1.5rem",
        width: '100%',
    },

    verificationContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",

        backgroundColor: "#F8F8F8",

        border: "1px solid #EDEDED",
        borderRadius: "4px",

        padding: "16px",
        marginBottom: "24px",

    },

    verificationContainer__title: {
        fontSize: "18px",
        fontWeight: "normal",
        fontFamily: "Lato, sans-serif",
        color: "#0C0E29",
    },

    verification__body: {
        color: "rgba(12, 14, 41, 0.8)",
    },

    primaryButton: {
        height: "40px",
        width: "fit-content",
        padding: "0 16px",

        border: "none",
        borderRadius: "4px",

        fontSize: "16px",
        color: "white",
        backgroundColor: "#C3996B",

        marginTop: "8px",

        transition: "all 0.2s ease-in-out",

        "&:hover": {
            backgroundColor: "#a77d4f",
            cursor: "pointer",
        }
    },

    buttonStyle: {
        backgroundColor: '#C3996B !important',
    },

    header: {
        width: "100%",
        height: "40px",

        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",

        marginBottom: "16px",
    },

    verifiedRow: {
        display: 'flex',
        width: '100%',
        justifyContent: 'end',
        alignItems: 'center'
    },

    formContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
    },

    labelText: {
        alignItems: 'center',
        display: 'flex',
        margin: "0px",
        marginBottom: '4px',
        fontWeight: '400',
        fontSize: '1rem',
        color: 'rgb(105, 105, 105) !important'
    },

    emailInputContainer: {
        width: "100%",
        height: "fit-content",
        position: "relative",
    },

    verifiedBadge: {
        height: "20px",
        width: "20px",

        display: "block",

        color: "#5CC958",
        strokeWidth: "1.6px",

        position: "absolute",
        top: "50%",
        right: "16px",
        transform: "translateY(-50%)",
    },

    verifiedText: {
        alignItems: 'center',
        display: 'flex',
        fontWeight: '400',
        fontSize: '1rem',
        color: 'rgb(105, 105, 105) !important'

    },

    logInButton: {
        height: "32px",
        padding: "0 12px",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        position: "relative",

        border: "none",
        borderRadius: "4px",

        fontSize: "16px",
        color: "white",
        backgroundColor: "#C3996B",

        transition: "all 0.2s ease-in-out",

        userSelect: "none",

        "&:hover": {
            backgroundColor: "#a77d4f",
            cursor: "pointer",
        }
    },
    titleTextStyle: {
        marginLeft: "20px",
    },
    titleSection: {
        width: "100%",
    },
    titleStyle: {
        paddingLeft: "10%",
        paddingRight: "10%",
        display: "flex",
        alignContent: "space-around",
        alignItems: "center",
        background: "#FFFFFF",
        justifyContent: "space-between"
    },
    dateAndCreateDiv: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'end',
        flexWrap: 'wrap',


    },
    activeFor: {
        color: "#696969",
        fontSize: "15px",
    },
    backIcon: {
        padding: "20px",
        cursor: "pointer"
    },
    iconItem: {
        display: 'flex !important',
        alignItems: 'center !important'
    },
    textField: {
        marginTop: '10px',
        marginBottom: '10px'
    },
    disabledTextField: {
        backgroundColor: '#dddddd'
    },

    buttonContainer: {
        width: "100%",

        display: "flex",
        justifyContent: "flex-end",

        marginTop: "16px",
    },

    primaryIconButton: {
        height: "40px",
        padding: "0 16px",
        paddingLeft: "8px",

        border: "none",
        borderRadius: "4px",

        fontSize: "16px",
        color: "white",
        backgroundColor: "#C3996B",

        display: "flex",
        gap: "8px",
        alignItems: "center",

        transition: "all 0.2s ease-in-out",

        "&:hover": {
            backgroundColor: "#a77d4f",
            color: "white",
            cursor: "pointer",
        }
    },

    iconButton__icon: {
        height: "20px",
        width: "20px",
        strokeWidth: "2px",

        display: "block",
    },

});